import WarningIcon from "@mui/icons-material/Warning";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { css, StyleSheet } from "aphrodite";
import { ReactNode, useState } from "react";
import { DragDropContext, Droppable, OnDragEndResponder } from "react-beautiful-dnd";
import { DraggableFormCellItem } from "../FormCell/DragAndDrop/DraggableFormCell";
import { DraggableFormRow } from "../FormCell/DragAndDrop/DraggableFormRow";
import { Row } from "../FormCell/DragAndDrop/DraggableItemTypes";
import { DropNewFormCell } from "../FormCell/DragAndDrop/DropNewFormCell";
import { FieldInfoDialog } from "../FormCell/DragAndDrop/FieldInfoDialog";
import * as auto_pi from "@crochik/auto-pi";
import { Button, IconButton, Typography } from "@mui/material";
import { useForm } from "../useForm";

interface Props {
    formPadding: number;
    isScreenTooSmall?: boolean;
    maxWidth?: number;
    onDropExisting(item: DraggableFormCellItem): void;
    onDropNew(item: DraggableFormCellItem): void;
    onReorder: OnDragEndResponder;
    onRender?(field: auto_pi.Field): ReactNode;
    rows: Row[];

    onEditField?(field?: auto_pi.Field): void;
    onEditAction?(action?: auto_pi.FormAction): void;
    onFormProperties?(): void;
}

export function CustomizeFormLayout(props: Props) {
    const { formPadding, isScreenTooSmall, maxWidth, onDropExisting, onDropNew, onReorder, rows, onEditField, onEditAction, onFormProperties, onRender } = props;
    const [selectedField, setSelectedField] = useState<auto_pi.Field>();
    const form = useForm();
    const onShowInfo = (field: auto_pi.Field) => {
        if (onEditField) {
            onEditField(field);
            return;
        }
        setSelectedField(field)
    };
    const onHideInfo = () => setSelectedField(undefined);

    const editAction = (action?: auto_pi.FormAction) => () => {
        onEditAction?.(action);
    }

    return (
        <div className={css(styles.form)} style={{ maxWidth: maxWidth || "100%", margin: formPadding }}>
            {/* {isScreenTooSmall && (
                <div className={css(styles.tooSmall)}>
                    <WarningIcon fontSize="small" />
                    <div>{"Current screen width smaller than target screen size"}</div>
                </div>
            )} */}
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                height: "50px",
                width: "100%",

                background: "#fff",
            }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: onFormProperties ? "pointer" : undefined,
                    }}
                    onClick={onFormProperties}
                >
                    <Typography color="primary" variant="h6">{form.Title ?? form.Name}</Typography>
                    {
                        onFormProperties && <IconButton color="primary" size="large"><EditIcon /></IconButton>
                    }

                </div>
            </div>

            <div style={{ height: "calc(100% - 100px)", overflow: 'auto', background: '#ddd' }}>
                <DragDropContext onDragEnd={onReorder}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {rows.map((row, rowIndex) => (
                                    <div className={css(styles.row)} key={`row-${rowIndex}`}>
                                        <DraggableFormRow row={row} rowIndex={rowIndex} onDrop={onDropExisting} onShowInfo={onShowInfo} onRender={onRender} />
                                        <DropNewFormCell rowIndex={rowIndex} onDrop={onDropNew} />
                                    </div>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
            <div style={{
                display: "flex",
                justifyContent: "space-evenly",
                height: "50px",
                padding: 8,
                width: "100%",
                cursor: "pointer",
                background: "#fff",
            }}>
                {form.Actions?.map(x => (
                    <Button variant="outlined" disabled={!onEditAction} onClick={editAction(x)} style={{ marginLeft: 4, marginRight: 4 }}>{x.Label ?? x.Name}</Button>
                ))}
                {
                    onEditAction && <IconButton color="primary" size="large" onClick={editAction()}><AddIcon /></IconButton>
                }
            </div>
            {selectedField && <FieldInfoDialog field={selectedField} onClose={onHideInfo} />}
        </div>
    );
}

const styles = StyleSheet.create({
    form: {
        borderColor: "#ddd",
        backgroundColor: "#fff",
        borderWidth: 2,
        borderStyle: "solid",
        borderRadius: 4,
        overflow: "auto",
        width: "100%",
    },
    tooSmall: {
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        backgroundColor: "#FFD54F",
        display: "flex",
        padding: 8,
    },
    row: {},
});

